/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrepareLlmTestResult } from '../../models/prepare-llm-test-result';

export interface ApiModelsLlmTestPreparePost$Params {
}

export function apiModelsLlmTestPreparePost(http: HttpClient, rootUrl: string, params?: ApiModelsLlmTestPreparePost$Params, context?: HttpContext): Observable<StrictHttpResponse<PrepareLlmTestResult>> {
  const rb = new RequestBuilder(rootUrl, apiModelsLlmTestPreparePost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrepareLlmTestResult>;
    })
  );
}

apiModelsLlmTestPreparePost.PATH = '/api/Models/llm/test/prepare';
